import gql from "graphql-tag"

export const GET_ORDERS = gql`
  query Orders {
    orders {
      total
      data {
        id
        orderNumber
        status
        totalAmount
        processTime
        submittedTime
        confirmedTime
        successTime
        cacelTime
        expectedDate
        updatedAt
        clientOrderNumber
        orderDetails {
          id
          unitPrice
          quantity
          sum
          product {
            id
            name
            productNumber
          }
        }
        company {
          id
          name
        }
        user {
          id
          name
        }
      }
    }
  }
`

export const GET_COMPANIES = gql`
  query Companies {
    companies {
      total
      data {
        id
        name
        area
      }
    }
  }
`
